module.exports = __webpack_public_path__ + "static/img/ag_7.4e9cee4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント2/ag_7.png
// module id = 883
// module chunks = 1